import {
  LogoPlanoAlpha,
  LogoPlanoBemEstar,
  LogoPlanoBemFlex,
  LogoPlanoBemSeguro,
  LogoPlanoEssencial,
  LogoPlanoFlex,
  LogoPlanoMultiassistencia,
  LogoPlanoNeo,
} from '@ferreri/prever-component-lib';

const commonIconProps = {
  height: 48,
  width: 216,
};

export const LogoMap = {
  essencial: <LogoPlanoEssencial {...commonIconProps} />,
  'bem-estar': <LogoPlanoBemEstar {...commonIconProps} />,
  'bem-seguro': <LogoPlanoBemSeguro {...commonIconProps} />,
  multi: <LogoPlanoMultiassistencia {...commonIconProps} />,
  neo: <LogoPlanoNeo {...commonIconProps} />,
  flex: <LogoPlanoFlex {...commonIconProps} />,
  'bem-flex': <LogoPlanoBemFlex {...commonIconProps} />,
  'bem-flex-empresarial': <LogoPlanoBemFlex {...commonIconProps} />,
  alpha: <LogoPlanoAlpha {...commonIconProps} />,
};
